import { createFeatureSelector } from '@ngrx/store';
import { FeatureState } from './feature.state';


export const FEATURE_NAME = 'component_share-with-installers';

export const featureState = createFeatureSelector<FeatureState>(FEATURE_NAME);
